// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'caret-left';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M11 14 6.1 9.236A.332.332 0 0 1 6 9a.325.325 0 0 1 .1-.236L11 4'
  />
);

export const viewBox = '0 0 18 18';
